export const MORE = 'More';
export const LESS = 'Less';